import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  TextField,
  Button,
  MenuItem,
  Typography,
  Grid,
  Box,
  InputLabel,
  Stack,
  Container,
  Alert,
  AlertTitle,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  useMediaQuery,
  Stepper,
  Step,
  StepLabel,
  FormHelperText,
  CircularProgress,
} from "@mui/material";
import axios from "axios";
import { tokens } from "../../../../../theme";
import { useTheme } from "@mui/material";
import { FormControl, OutlinedInput } from "@mui/material";
import { IconButton, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import otpImage from "../../../../../components/varification_img.avif";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useAuth } from "../../../components/AuthContext";
import SendIcon from "@mui/icons-material/Send";
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
const qualificationOptions = [
  "BE",
  "BTech",
  "MCA",
  "MSc",
  "ME",
  "MTech",
  "Other",
];

export default function SelectedForm() {
  const { id } = useParams();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [error, setError] = useState(null);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [showOtpScreen, setShowOtpScreen] = useState(true);
  const [jobData, setJobData] = useState(null);
  const [isFormAlreadySubmitted, setIsFormAlreadySubmitted] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [filePreviews, setFilePreviews] = useState({});
  const [invalidFiles, setInvalidFiles] = useState({});
  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [dialogMessage, setDialogMessage] = useState("");
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));
  const isVerySmallScreen = useMediaQuery("(max-width:580px)");
  const isTabletOrBelow = useMediaQuery("(max-width:900px)");
  const [activeStep, setActiveStep] = useState(0);
  const { setOtpVerification, setEmail } = useAuth();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [progress, setProgress] = useState(0);
  const [website, setWebsite] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
const [isResendingOtp, setIsResendingOtp] = useState(false);
const [sendOtpProgress, setSendOtpProgress] = useState(0);
const [verifyOtpProgress, setVerifyOtpProgress] = useState(0);
const [resendOtpProgress, setResendOtpProgress] = useState(0);
const [dialogProgress, setDialogProgress] = useState(0);
const [showCheckmark, setShowCheckmark] = useState(false);
const [progressDialogStage, setProgressDialogStage] = useState("submitting"); // "submitting", "success", "error"
const [showIcon, setShowIcon] = useState(false);
  const [allowedFileTypes] = useState([
    "application/pdf",
    "image/jpeg",
    "image/png",
    "image/gif",
    "text/csv",
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ]);

  const steps = ["Candidate Details & References", "Qualification & Documents"];

  const [formData, setFormData] = useState({
    professionalReference1: "",
    professionalReference2: "",
    highestQualification: "",
    otherQualification: "",
    latestPaySlip: null,
    lastAppointmentLetter: null,
    degreeCertificate: null,
    identityProof: null,
    referencenumber1: "",
    referenceemail1: "",
    renferencenumber2: "",
    referenceemail2: "",
  });
  const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user
    ?.stsTokenManager?.accessToken;
  const getOtp = () => otp.join("");

  const fieldsPerStep = {
    0: ["referencenumber1", "referenceemail1", "professionalReference1","professionalReference2" ,"renferencenumber2","referenceemail2"],
    1: ["highestQualification", "identityProof", "degreeCertificate"],
  };

  useEffect(() => {
    let sendInterval, verifyInterval, resendInterval, submitInterval;
  
    if (isSendingOtp) {
      sendInterval = setInterval(() => {
        setSendOtpProgress((prev) => {
          if (prev >= 100) return 100;
          return prev + 25;
        });
      }, 500);
    }
  
    if (isVerifyingOtp) {
      verifyInterval = setInterval(() => {
        setVerifyOtpProgress((prev) => {
          if (prev >= 100) return 100;
          return prev + 25;
        });
      }, 500);
    }
  
    if (isResendingOtp) {
      resendInterval = setInterval(() => {
        setResendOtpProgress((prev) => {
          if (prev >= 100) return 100;
          return prev + 25;
        });
      }, 500);
    }
  
    if (dialogOpen && progressDialogStage === "submitting") {
      submitInterval = setInterval(() => {
        setDialogProgress((prevProgress) => {
          if (prevProgress >= 90) return 90; // Keep at 90% until server responds
          return prevProgress + 10;
        });
      }, 200);
    } else if (dialogOpen && (progressDialogStage === "success" || progressDialogStage === "error")) {
      setDialogProgress(100);
      setTimeout(() => setShowIcon(true), 300);
    }
  
    return () => {
      clearInterval(sendInterval);
      clearInterval(verifyInterval);
      clearInterval(resendInterval);
      clearInterval(submitInterval);
    };
  }, [isSendingOtp, isVerifyingOtp, isResendingOtp, dialogOpen, progressDialogStage]);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get-config`);
        const data = await res.json();
        if (res.ok) {
          // setEmail(data.email || "");
          setWebsite(data.website || "");
        }
      } catch (err) {
        console.error("Error fetching config:", err);
      }
    };
    fetchConfig();
  }, []);

  useEffect(() => {
    if (dialogOpen) {
      // Reset states when dialog opens
      setDialogProgress(0);
      setShowCheckmark(false);
      
      // Start progress animation
      const timer = setInterval(() => {
        setDialogProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(timer);
            // Show checkmark after a small delay
            setTimeout(() => setShowCheckmark(true), 200);
            return 100;
          }
          return prevProgress + 2; // Increase by 2% every 50ms (will complete in 2.5 seconds)
        });
      }, 50);
  
      return () => clearInterval(timer);
    }
  }, [dialogOpen]);
  
  useEffect(() => {
    if (!id) {
      return;
    }
    const fetchJobApplication = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/job_application/form/${id}`,
          {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          }
        );
        setJobData(response.data);
        const fetchedData = response.data;

        setFormData((prevData) => ({
          ...prevData,
          professionalReference1: fetchedData.professionalReference1 || "",
          professionalReference2: fetchedData.professionalReference2 || "",
          highestQualification: fetchedData.highestQualification || "",
          latestPaySlip: fetchedData.latestPaySlip || null, // You can also store URL or File
          lastAppointmentLetter: fetchedData.lastAppointmentLetter || null,
          degreeCertificate: fetchedData.degreeCertificate || null,
          identityProof: fetchedData.identityProof || null,
          referencenumber1: fetchedData.referencenumber1 || "",
          referenceemail1: fetchedData.referenceemail1 || "",
          renferencenumber2: fetchedData.renferencenumber2 || "",
          referenceemail2: fetchedData.referenceemail2 || "",
        }));
        const formSelectedSubmitted = fetchedData?.form_selected_submitted;
        if (formSelectedSubmitted === true) {
          setShowOtpScreen(false);
          setIsFormAlreadySubmitted(true);
        } else {
          setIsFormAlreadySubmitted(false);
        }
      } catch (error) {
        console.error("Error fetching job application:", error);
      }
    };

    if (id) {
      fetchJobApplication();
    }
  }, [id]);

  const handleOtpChange = (e, index) => {
    const value = e.target.value.replace(/\D/g, ""); // accept only digits
    const updatedOtp = [...otp];

    if (value.length === 1) {
      updatedOtp[index] = value;
      setOtp(updatedOtp);

      // Move to next box if exists
      const nextInput = document.querySelector(`input[name=otp-${index + 1}]`);
      if (nextInput) nextInput.focus();
    }

    // Handle paste of multiple digits
    if (value.length > 1) {
      for (let i = 0; i < value.length && index + i < otp.length; i++) {
        updatedOtp[index + i] = value[i];
      }
      setOtp(updatedOtp);

      const nextInput = document.querySelector(
        `input[name=otp-${index + value.length}]`
      );
      if (nextInput) nextInput.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const updatedOtp = [...otp];

      if (otp[index]) {
        updatedOtp[index] = "";
        setOtp(updatedOtp);
      } else if (index > 0) {
        updatedOtp[index - 1] = "";
        setOtp(updatedOtp);
        const prevInput = document.querySelector(
          `input[name=otp-${index - 1}]`
        );
        if (prevInput) prevInput.focus();
      }
    }

    if (e.key === "ArrowLeft" && index > 0) {
      const prevInput = document.querySelector(`input[name=otp-${index - 1}]`);
      if (prevInput) prevInput.focus();
    }

    if (e.key === "ArrowRight" && index < otp.length - 1) {
      const nextInput = document.querySelector(`input[name=otp-${index + 1}]`);
      if (nextInput) nextInput.focus();
    }
  };

  const handleSendOtp = async () => {
    setIsSendingOtp(true);
    setSendOtpProgress(25);
    setOtpVerification(false);
    setEmail(jobData?.email);
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/send-otp-email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ id: id, status: "Selected" }),
        }
      );
  
      const data = await response.json();
  
      if (response.ok) {
        setIsOtpSent(true);
        setError("");
        setSendOtpProgress(100);
      } else {
        setError(data.message || "Failed to send OTP. Please try again.");
        setSendOtpProgress(0);
      }
    } catch (err) {
      setError("Failed to send OTP. Please try again.");
      setSendOtpProgress(0);
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleResendOtp = async () => {
    setIsResendingOtp(true);
    setResendOtpProgress(25);
    setOtpVerification(false);
    setEmail(jobData?.email);   
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/send-otp-email`,
        {
          id,
          is_resend: true,
          status: "Selected",
        }
      );
  
      if (response.status === 200) {
        setIsOtpSent(true);
        setOtp(["", "", "", "", "", ""]);
        setError("");
        // setDialogTitle("OTP Resent");
        setDialogMessage("OTP has been resent.");
        setDialogOpen(true);
        setResendOtpProgress(100);
      }
    } catch (err) {
      console.error(err);
      setError("Failed to resend OTP.");
      setResendOtpProgress(0);
    } finally {
      setIsResendingOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    setIsVerifyingOtp(true);
    setVerifyOtpProgress(25);
    try {
      const otpValue = getOtp();
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/verify-otp`,
        {
          otp: otpValue,
          id,
          status: "Selected",
        }
      );
  
      if (res.data.status === "verified") {
        setOtpVerification(true);
        setShowOtpScreen(false);
        setFormData(res.data.formData);
        setError("");
        setVerifyOtpProgress(100);
      } else {
        setError("Invalid OTP");
        setVerifyOtpProgress(0);
      }
    } catch (err) {
      console.error(err);
      setError("OTP verification failed");
      setVerifyOtpProgress(0);
    } finally {
      setIsVerifyingOtp(false);
    }
  };
  

  const handleChange = (e) => {
    const { name, value, files, type } = e.target;
  
    if (type === "file") {
      const file = files[0];
      if (!file) return;
  
      if (!allowedFileTypes.includes(file.type)) {
        setInvalidFiles((prev) => ({
          ...prev,
          [name]: true,
        }));
        setError((prev) => ({
          ...prev,
          [name]: "Invalid file type. Please upload a valid jpg,png,pdf and word file.",
        }));
        return;
      } else {
        setInvalidFiles((prev) => ({
          ...prev,
          [name]: false,
        }));
  
        setError((prev) => {
          const { [name]: _, ...rest } = prev;
          return rest;
        });
      }
  
      const fileURL = URL.createObjectURL(file);
      setFilePreviews((prev) => ({
        ...prev,
        [name]: fileURL,
      }));
  
      setFormData((prev) => ({
        ...prev,
        [name]: file,
      }));
    } else {
      // Update form data first
      const updatedFormData = {
        ...formData,
        [name]: value,
      };
      
      setFormData(updatedFormData);
  
      // Real-time validation - validate only the current field
      const fieldErrors = validateFields([name], updatedFormData);
      
      setError((prevErrors) => {
        const newErrors = { ...prevErrors };
        
        // If field is now valid, remove its error
        if (!fieldErrors[name]) {
          delete newErrors[name];
        } else {
          // If field has error, update it
          newErrors[name] = fieldErrors[name];
        }
        
        return newErrors;
      });
    }
  };
  
  // Updated validateFields function to accept formData parameter
  const validateFields = (fieldsToValidate = [], formDataToValidate = null) => {
    const newErrors = {};
    const safeFormData = formDataToValidate || formData || {};
  
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const contactRegex = /^\d{10}$/;
  
    if (fieldsToValidate.includes("referencenumber1")) {
      if (
        !safeFormData.referencenumber1 ||
        safeFormData.referencenumber1.trim() === ""
      ) {
        newErrors.referencenumber1 = "Contact number is required";
      } else if (!contactRegex.test(safeFormData.referencenumber1.trim())) {
        newErrors.referencenumber1 = "Enter a valid 10-digit number";
      }
    }
  
    if (fieldsToValidate.includes("referenceemail1")) {
      if (
        !safeFormData.referenceemail1 ||
        safeFormData.referenceemail1.trim() === ""
      ) {
        newErrors.referenceemail1 = "Email address is required";
      } else if (!emailRegex.test(safeFormData.referenceemail1.trim())) {
        newErrors.referenceemail1 = "Enter a valid email address";
      }
    }
  
    if (fieldsToValidate.includes("renferencenumber2")) {
      const val = safeFormData.renferencenumber2?.trim() || "";
      if (val && !contactRegex.test(val)) {
        newErrors.renferencenumber2 = "Enter a valid 10-digit number";
      }
    }
  
    if (fieldsToValidate.includes("referenceemail2")) {
      const val = safeFormData.referenceemail2?.trim() || "";
      if (val && !emailRegex.test(val)) {
        newErrors.referenceemail2 = "Enter a valid email address";
      }
    }
  
  
  
    if (fieldsToValidate.includes("professionalReference1")) {
      const value = safeFormData.professionalReference1?.trim() || "";
      if (value === "") {
        newErrors.professionalReference1 = "Professional reference is required";
      } else if (!/^[a-zA-Z.\s]+$/.test(value)) {
        newErrors.professionalReference1 =
          "Only letters, spaces, and periods are allowed (e.g., 'Mr. John Doe')";
      }
    }
  
    // Add validation for professionalReference2 when it's being validated individually
    if (fieldsToValidate.includes("professionalReference2")) {
      const name2 = safeFormData.professionalReference2?.trim() || "";
      if (name2 && !/^[a-zA-Z.\s]+$/.test(name2)) {
        newErrors.professionalReference2 = "Only letters, spaces, and periods are allowed (e.g., 'Mr. John Doe')";
      }
    }
  
    if (fieldsToValidate.includes("highestQualification")) {
      if (
        !safeFormData.highestQualification ||
        safeFormData.highestQualification.trim() === ""
      ) {
        newErrors.highestQualification = "Highest qualification is required";
      }
    }
  
    if (fieldsToValidate.includes("identityProof")) {
      if (!safeFormData.identityProof) {
        newErrors.identityProof = "Identity proof is required";
      }
      if (invalidFiles.identityProof) {
        newErrors.identityProof = "Invalid file type for identity proof";
      }
    }
  
    if (fieldsToValidate.includes("degreeCertificate")) {
      if (!safeFormData.degreeCertificate) {
        newErrors.degreeCertificate = "Degree certificate is required";
      }
      if (invalidFiles.degreeCertificate) {
        newErrors.degreeCertificate =
          "Invalid file type for degree certificate";
      }
    }
  
    if (
      fieldsToValidate.includes("latestPaySlip") &&
      invalidFiles.latestPaySlip
    ) {
      newErrors.latestPaySlip = "Invalid file type for latest pay slip";
    }
  
    if (
      fieldsToValidate.includes("lastAppointmentLetter") &&
      invalidFiles.lastAppointmentLetter
    ) {
      newErrors.lastAppointmentLetter =
        "Invalid file type for last appointment letter";
    }
  
    return newErrors;
  };

  const handleNext = () => {
    const currentFields = fieldsPerStep[activeStep] || [];
    const currentErrors = validateFields(currentFields);


    if (Object.keys(currentErrors).length > 0) {
      setError(currentErrors);
    } else {
      setError({});
      if (activeStep < steps.length - 1) {
        setActiveStep((prev) => prev + 1);
      } else {
        handleSubmit();
      }
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleDownload = (fileUrl) => {
    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileUrl.split("/").pop();
    a.click();
  };

  const handleSubmit = async () => {
    // Validate form first before showing any dialog
    const errors = validateFields([
      "referencenumber1",
      "referenceemail1",
      "renferencenumber2",
      "referenceemail2",
      "professionalReference1",
      "highestQualification",
      "identityProof",
      "degreeCertificate",
      "latestPaySlip",
      "lastAppointmentLetter",
      "otherQualification", // Add otherQualification to validation
    ]);
  
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return; // Stop here - don't show dialog for validation errors
    }
  
    setError({});
  
    // Only show dialog if validation passes
    setIsSubmitting(true);
    setDialogOpen(true);
    setProgressDialogStage("submitting");
    setDialogProgress(0);
    setShowIcon(false);
    setDialogTitle("Submitting");
    setDialogMessage("Submitting your application...");
  
    try {
      const formPayload = new FormData();
      formPayload.append("id", id);
      formPayload.append(
        "professionalReference1",
        formData.professionalReference1 || ""
      );
      formPayload.append(
        "professionalReference2",
        formData.professionalReference2 || ""
      );
      // If highestQualification is "Other", use otherQualification value, otherwise use highestQualification
      formPayload.append(
        "highestQualification",
        formData.highestQualification === "Other"
          ? formData.otherQualification || ""
          : formData.highestQualification || ""
      );
      formPayload.append("referencenumber1", formData.referencenumber1 || "");
      formPayload.append("referenceemail1", formData.referenceemail1 || "");
      formPayload.append("renferencenumber2", formData.renferencenumber2 || "");
      formPayload.append("referenceemail2", formData.referenceemail2 || "");
  
      [
        "latestPaySlip",
        "lastAppointmentLetter",
        "degreeCertificate",
        "identityProof",
      ].forEach((field) => {
        const file = formData[field];
        if (file instanceof File) {
          formPayload.append(field, file);
        }
      });
  
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL_HRM}/selected-form`,
        {
          method: "POST",
          body: formPayload, // do NOT set Content-Type manually
        }
      );
  
      const result = await response.json().catch(() => response.text());
  
      if (response.ok) {
        setProgressDialogStage("success");
        setDialogTitle("Form Submitted Successfully");
        setDialogMessage("Thank you! Your selected form has been submitted successfully.");
        setIsFormAlreadySubmitted(true);
        setShowOtpScreen(false);
      } else {
        setProgressDialogStage("error");
        setDialogTitle("Something Went Wrong");
        setDialogMessage(
          "We couldn’t submit your select form. Please refresh the page or try later."
        );
        setError({ general: result.error || "Submission failed" });
      }
    } catch (error) {
      console.error("Submission error:", error);
      setProgressDialogStage("error");
      setDialogTitle("Something Went Wrong");
      setDialogMessage("We couldn’t submit your select form. Please refresh the page or try later.");
      setError({ general: "Network or server error" });
    } finally {
      setIsSubmitting(false); // Reset submitting state
    }
  };
  const inputPropsStyle = {
    sx: {
      width: "100%", // Add this
      borderRadius: "15px",
      backgroundColor: "transparent",
      color:"rgb(46, 43, 43)",

      "& .MuiOutlinedInput-root": {
        width: "100%", // Add this
        borderRadius: "15px",
        fontSize: "18px",
        fontFamily: "Lexend",
        color: "rgb(46, 43, 43)",
        px: { xs: 1.5, sm: 2 },
      },

      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa",
        borderRadius: "15px",
      },

      "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#aaa !important",
      },

      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#3DA3C4 !important",
        borderWidth: "2px",
      },

      "& input": {
        width: "100%", // Add this to control input box
        color: "rgb(46, 43, 43)",
        fontSize: { xs: "17px", sm: "18px" },
        fontFamily: "Lexend",
      },

      "& textarea": {
        color: "rgb(46, 43, 43)",
        fontSize: { xs: "17px", sm: "18px" },
        fontFamily: "Lexend",
      },

      "& .MuiFormHelperText-root": {
        fontSize: "16px",
        fontFamily: "Lexend",
      },
    },
  };

  const inputLabelPropsStyle = {
    shrink: true,
    sx: {
      color: "#000",
      fontSize: "16px",
      fontweight: "500",
      fontFamily: "Lexend",
      marginBottom: "5px",
      "&.Mui-focused": {
        color: "#000",
      },
    },
  };

  const labelStyle = {
    fontFamily: "Lexend",
    lineHeight: "1.4375em",
    position: "relative",
    transformOrigin: "left top",
    fontWeight: 500,
    fontSize: { xs: "16px", sm: "18px" }, // responsive font size
    color: "rgb(10, 10, 10)",
    marginBottom: "6px",
    display: "block",
    padding: 0,
    whiteSpace: "normal",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    transition:
      "color 200ms cubic-bezier(0, 0, 0.2, 1), transform 200ms cubic-bezier(0, 0, 0.2, 1), max-width 200ms cubic-bezier(0, 0, 0.2, 1)",
  };

  const commonButtonStyle = {
    borderRadius: "50px",
    border: "2px solid #0087B4",
    color: "#0087B4",
    padding: "14px 28px", // More padding
    fontSize: "20px", // Larger text
    display: "flex",
    alignItems: "center",
    fontWeight: 500,
    textTransform: "none",
    backgroundColor: "#FFFFFFD9",
    fontFamily: "Lexend",
    minWidth: "180px", // Wider button
    height: "55px", // Taller button
    "&:hover": {
      backgroundColor: "#0087B4",
      color: "#FFFFFFD9",
    },
  };

  if (showOtpScreen) {
    return (
      <Box
        sx={{
          mt: { xs: 8, md: 8 },
          display: "flex",
          flexDirection: "row",
          "@media (max-width: 1105px)": {
            flexDirection: "column",
          },
          alignItems: "center",
          justifyContent: "center",
          px: { xs: 2, sm: 4, md: 6, lg: 12 },
          py: { xs: 4, md: 8 },
          gap: { xs: 4, md: 6 },
          width: "100%",
          maxWidth: "100vw",
          minHeight: "87vh",
          boxSizing: "border-box",
          overflow: "hidden",
          textAlign: "left",
          "@media (max-width:1105px)": {
            flexDirection: "column",
            alignItems: "center",
          },
        }}
      >
        {(isSendingOtp || isVerifyingOtp || isResendingOtp) && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1300,
          }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              backgroundColor: "white",
              padding: 4,
              borderRadius: 2,
            }}
          >
            <CircularProgress
              variant="determinate"
              value={
                isSendingOtp
                  ? sendOtpProgress
                  : isVerifyingOtp
                  ? verifyOtpProgress
                  : resendOtpProgress
              }
              size={60}
              thickness={4}
              sx={{ color: "#0087B4" }}
            />
            <Typography sx={{ mt: 2, color: "#333", fontFamily: "Lexend", fontSize: "18px" }}>
              {isSendingOtp
                ? "Sending OTP..."
                : isVerifyingOtp
                ? "Verifying OTP..."
                : "Resending OTP..."}
            </Typography>
          </Box>
        </Box>
      )}
        <Box
          sx={{
            order: 1,
            width: { xs: "100%", md: "45%", lg: "40%" },
            maxWidth: { xs: "700px", md: "600px" },
            mb: { xs: 4, md: 0 },
            textAlign: "center",
            flexShrink: 0,
            "& img": {
              width: "100%",
              height: "auto",
              maxWidth: { xs: "700px", md: "100%" },
              objectFit: "contain",
            },
            "@media (max-width: 1105px)": {
              order: -1,
              width: "100%",
              maxWidth: "700px",
              mb: 4,
            },
          }}
        >
          <img
            src={otpImage}
            alt="OTP Illustration"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "100%",
              objectFit: "contain",
              display: "block",
              margin: "0 auto",
              borderRadius: "15px",
            }}
          />
        </Box>

        {/* Content Section */}
        <Box
          sx={{
            order: 0,
            width: { xs: "100%", md: "55%", lg: "50%" },
            maxWidth: "600px",
            px: { xs: 1, sm: 2 },
            textAlign: "left",
            transform: {
              xs: "translateX(0)",
              sm: "translateX(-1%)",
              md: "translateX(-2%)",
              lg: "translateX(-4%)",
              xl: "translateX(0%)",
            },
            transition: "transform 0.3s ease",
            "@media (max-width:1105px)": {
              order: 0,
              width: "100%",
              maxWidth: "700px",
            },
          }}
        >
          <Typography
            variant="h3"
            sx={{
              fontSize: { xs: "36px", sm: "38px", md: "40px", lg: "40px" },
              fontWeight: "500",
              mb: 2,
              textAlign: "left",
              fontFamily: "Lexend",
              color: "#000000DE",
            }}
          >
            Welcome, {jobData?.name} - Complete OTP Verification to proceed
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          {!isOtpSent ? (
            <>
              <Typography
                sx={{
                  fontSize: "16px",
                  mb: 2,
                  textAlign: "left",
                  fontFamily: "Lexend",
                  color: "#555555",
                }}
              >
                Click "Send OTP" to receive a verification code on your email.
              </Typography>
              <Button
                variant="contained"
                onClick={handleSendOtp}
                sx={{
                  mt: 2,
                  borderRadius: "50px",
                  border: "2px solid #0087B4",
                  color: "#0087B4",
                  padding: "10px 20px",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 380,
                  textTransform: "none",
                  backgroundColor: "#FFFFFFD9",
                  boxShadow: "none",
                  "&:hover": {
                    backgroundColor: "#0087B4",
                    color: "#FFFFFFD9",
                    boxShadow: "none",
                  },
                }}
              >
                Send OTP
              </Button>
            </>
          ) : (
            <>
              <Typography
                sx={{
                  fontSize: "18px",
                  mb: 2,
                  textAlign: "left",
                  fontFamily: "Lexend",
                  color: "#000000DE",
                }}
              >
                Please enter the 6-digit OTP sent to your email
              </Typography>

              <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                {otp.map((digit, index) => (
                  <TextField
                    key={index}
                    name={`otp-${index}`}
                    value={digit}
                    onChange={(e) => handleOtpChange(e, index)}
                    onKeyDown={(e) => handleKeyDown(e, index)}
                    inputProps={{
                      maxLength: 1,
                      style: {
                        textAlign: "center",
                        fontSize: "18px",
                        padding: 0,
                        fontFamily: "Lexend",
                        color: "#000000DE",
                      },
                    }}
                    sx={{
                      width: "61px",
                      height: "50px",
                      fontSize: "18px",
                      fontFamily: "Lexend",
                      color: "#000000DE",
                      borderRadius: "15px",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "15px",
                        height: "100%",
                      },
                    }}
                  />
                ))}
              </Box>

              <Button
                variant="contained"
                onClick={handleVerifyOtp}
                sx={{
                  mb: 2,
                  width: "170px",
                  borderRadius: "50px",
                  border: "2px solid #0087B4",
                  color: "#0087B4",
                  padding: "10px 20px",
                  fontSize: "18px",
                  display: "flex",
                  alignItems: "center",
                  fontWeight: 380,
                  textTransform: "none",
                  backgroundColor: "#FFFFFFD9",
                  boxShadow: "none", 
                  "&:hover": {
                    backgroundColor: "#0087B4",
                    color: "#FFFFFFD9",
                    boxShadow: "none", 
                  },
                }}
              >
                Verify OTP
              </Button>

              <Box>
                <Button
                  onClick={handleResendOtp}
                  sx={{
                    mt: 1,
                    color: "#0087B4",
                    padding: 0,
                    pl:3,
                    fontSize: "18px",
                    fontWeight: 380,
                    textTransform: "none",
                    backgroundColor: "transparent",
                    minWidth: "auto",
                    "&:hover": {
                      backgroundColor: "transparent",
                    },
                    "&:active": {
                      backgroundColor: "transparent",
                    },
                    "&:focus": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  Resend OTP
                </Button>
              </Box>

              <Dialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                PaperProps={{
                  sx: {
                    width: 450,
                    maxWidth: "90vw",
                    padding: 2,
                    fontSize: "18px",
                    fontFamily: "Lexend",
                    color: "#000000DE",
                    borderRadius: "19px",
                  },
                }}
              >
                <DialogTitle sx={{ fontFamily: "Lexend", fontWeight:400}}>{dialogTitle}</DialogTitle>
                <DialogContent>
                  <Typography sx={{  fontFamily: "Lexend", fontWeight:300, color:'#000000DE'}}>{dialogMessage}</Typography>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setDialogOpen(false)} sx={{ fontFamily: "Lexend", color:'#0087B4'}}>OK</Button>
                </DialogActions>
              </Dialog>
            </>
          )}
        </Box>
      </Box>
    );
  }



  return (
    <Box
      sx={{
        width: "100%",
        mt: {
          xs: "80px",
          md: "120px",
          boxSizing: "border-box",
          overflowX: "hidden",
        },
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1480px",
          mx: "auto",
          boxSizing: "border-box",
          paddingLeft: { xs: "12px", sm: "24px", md: "32px" },
          paddingRight: { xs: "12px", sm: "24px", md: "32px" },
          "@media (min-width:900px)": {
            paddingLeft: "125px",
            paddingRight: "85px",
          },
        }}
      >
        <Grid
          container
          spacing={2}
          direction={isSmallScreen ? "column" : "row"}
          alignItems={isSmallScreen ? "center" : "flex-start"}
        >
          {/* Stepper */}
          <Grid
            item
            xs={12}
            md={3}
            sx={{
              mb: isSmallScreen ? 3 : 0,
              mt: isSmallScreen ? 2 : 0,
              pl: isSmallScreen ? 1 : 0,
              display: isVerySmallScreen ? "flex" : "block",
              justifyContent: isVerySmallScreen ? "center" : "flex-start",
              "@media (max-width:900px)": {
                mt: "36px",
              },
            }}
          >
            <Stepper
              activeStep={activeStep}
              orientation={isSmallScreen ? "horizontal" : "vertical"}
              alternativeLabel={isSmallScreen}
              sx={{
                width: "100%",
                justifyContent: isSmallScreen ? "center" : "flex-start",
                "& .MuiStepIcon-root": {
                  color: "#0087B4",
                  fontSize: "1.95rem", 
                },
                "& .MuiStepIcon-root.Mui-completed": {
                  color: "#0087B4",
                  fontSize: "1.95rem", 
                },
                "& .MuiStepIcon-root.Mui-active": {
                  color: "#0087B4",
                  fontSize: "1.95rem",
                },
                "& .MuiStepConnector-line": {
                  borderColor: "#00002D",
                },
              }}
            >
              {steps.map((label) => (
                <Step key={label}>
                  <StepLabel
                    sx={{
                      "& .MuiStepLabel-label": {
                        fontSize: "18px",
                        fontFamily: "Lexend",
                        color: "#000000DE",
                        textAlign: isSmallScreen ? "center" : "inherit",
                      },
                    }}
                  >
                    {label}
                  </StepLabel>
                </Step>
              ))}
            </Stepper>
          </Grid>

          <Grid item xs={12} md={9} sx={{mt: "12px", }}>
            {activeStep === 0 && (
              <>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: "500",
                    fontSize: "28px",
                    fontFamily: "Lexend",
                    color: "#000000DE",
                  }}
                >
                  Candidate Details & References
                </Typography>
                {isFormAlreadySubmitted && (
                  <Alert
                    severity="success"
                    sx={{
                      mt: 4,
                      mb: 4,
                      backgroundColor: colors.primary,
                      fontSize: "18px",
                      fontFamily: "Lexend",
                      color: "#000000DE",
                    }}
                  >
                    Form has already been submitted.
                  </Alert>
                )}
                <Grid container spacing={2} sx={{ mt: 4 }}>
                  <Grid
                    item
                    xs={12}
                    sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                  >
                    <Typography sx={labelStyle}>Name</Typography>
                    <TextField
                      fullWidth
                      value={
                        [
                          jobData?.name,
                          jobData?.Middle_Name,
                          jobData?.Last_Name
                        ]
                        .map(part => (part && part !== "null") ? part : "") // Filters out null and "null" strings
                        .filter(Boolean) // Removes empty strings
                        .join(" ")
                      }
                      disabled
                      InputProps={{
                        readOnly: true,
                        sx: {
                          input: {
                            paddingLeft: "0.2px", 
                            color: "#000",
                          },
                        },
                      }}
                      sx={inputPropsStyle.sx}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                  >
                    <Typography sx={labelStyle}>Job Title</Typography>
                    <TextField
                      fullWidth
                      value={jobData?.job_title || ""}
                      disabled
                      InputProps={{
                        readOnly: true,
                        sx: {
                          input: {
                            paddingLeft: "0.2px", 
                            color: "#000",
                          },
                        },
                      }}
                      sx={inputPropsStyle.sx}
                    />
                  </Grid>

                  {/* Second column: Email and Mobile Number */}
                  <Grid
                    item
                    xs={12}
                    sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                  >
                    <Typography sx={labelStyle}>Email</Typography>
                    <TextField
                      fullWidth
                      value={jobData?.email || ""}
                      disabled
                      InputProps={{
                        readOnly: true,
                        sx: {
                          input: {
                            paddingLeft: "0.2px", 
                            color: "#000",
                          },
                        },
                      }}
                      sx={inputPropsStyle.sx}
                    />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={isTabletOrBelow || isVerySmallScreen ? 12 : 6}
                  >
                    <Typography sx={labelStyle}>Mobile No.</Typography>
                    <TextField
                      fullWidth
                      value={jobData?.mobile_no || ""}
                      disabled
                      InputProps={{
                        readOnly: true,
                        sx: {
                          input: {
                            paddingLeft: "0.2px", 
                            color: "#000",
                          },
                        },
                      }}
                      sx={inputPropsStyle.sx}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography sx={labelStyle}>
                      Professional Reference 1 <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      required
                      fullWidth
                      placeholder="Enter Reference person name "
                      disabled={isFormAlreadySubmitted}
                      name="professionalReference1"
                      value={formData?.professionalReference1 || ""}
                      onChange={handleChange}
                      InputProps={inputPropsStyle}
                      error={!!error?.professionalReference1}
                      helperText={error?.professionalReference1}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={isTabletOrBelow ? 12 : 6}>
                        <Typography sx={labelStyle}>
                          Contact Number <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                          required
                          fullWidth
                          disabled={isFormAlreadySubmitted}
                          name="referencenumber1"
                          placeholder="10-digit number "
                          value={formData?.referencenumber1 || ""}
                          onChange={handleChange}
                          InputProps={inputPropsStyle}
                          InputLabelProps={inputLabelPropsStyle}
                          error={!!error?.referencenumber1}
                          helperText={error?.referencenumber1}
                        />
                      </Grid>
                      <Grid item xs={12} sm={isTabletOrBelow ? 12 : 6}>
                        <Typography sx={labelStyle}>Email Address <span style={{ color: "red" }}>*</span></Typography>
                        <TextField
                          required
                          fullWidth
                          disabled={isFormAlreadySubmitted}
                          name="referenceemail1"
                          placeholder="Enter reference email address "
                          value={formData?.referenceemail1 || ""}
                          onChange={handleChange}
                          InputProps={inputPropsStyle}
                          InputLabelProps={inputLabelPropsStyle}
                          error={!!error?.referenceemail1}
                          helperText={error?.referenceemail1}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography sx={labelStyle}>
                      Professional Reference 2
                    </Typography>
                    <TextField
                      fullWidth
                      name="professionalReference2"
                      placeholder="Enter second Reference person name "
                      disabled={isFormAlreadySubmitted}
                      value={formData?.professionalReference2 || ""}
                      onChange={handleChange}
                      InputProps={inputPropsStyle}
                      InputLabelProps={inputLabelPropsStyle}
                      error={!!error?.professionalReference2}
                      helperText={error?.professionalReference2}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={isTabletOrBelow ? 12 : 6}>
                        <Typography sx={labelStyle}>Contact Number</Typography>
                        <TextField
                          fullWidth
                          disabled={isFormAlreadySubmitted}
                          name="renferencenumber2"
                          placeholder="10-digit number "
                          value={formData?.renferencenumber2 || ""}
                          onChange={handleChange}
                          InputProps={inputPropsStyle}
                          error={!!error?.renferencenumber2}
                          helperText={error?.renferencenumber2}
                          type="tel"
                          inputProps={{
                            pattern: "[0-9]*",
                            maxLength: 10,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={isTabletOrBelow ? 12 : 6}>
                        <Typography sx={labelStyle}>Email Address</Typography>
                        <TextField
                          fullWidth
                          disabled={isFormAlreadySubmitted}
                          name="referenceemail2"
                          placeholder="Enter second reference email address "
                          value={formData?.referenceemail2 || ""}
                          onChange={handleChange}
                          InputProps={inputPropsStyle}
                          error={!!error?.referenceemail2}
                          helperText={error?.referenceemail2}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </>
            )}

            {activeStep === 1 && (
              <>
                <Typography
                  variant="h5"
                  gutterBottom
                  sx={{
                    fontWeight: "500",
                    fontSize: "28px",
                    fontFamily: "Lexend",
                    color: "rgba(0, 0, 0, 0.87)",
                  }}
                >
                  Qualification & Documents
                </Typography>

                {isFormAlreadySubmitted && (
                  <Alert
                    severity="success"
                    sx={{
                      mt: 4,
                      mb: 4,
                      backgroundColor: colors.primary,
                      fontSize: "18px",
                      fontFamily: "Lexend",
                      color: "rgba(0, 0, 0, 0.87)",
                    }}
                  >
                    Form has already been submitted.
                  </Alert>
                )}
             <Grid container spacing={2} sx={{ mt: 4 }}>
  <Grid item xs={12}>
    <Typography sx={labelStyle}>
      Highest Qualification <span style={{ color: "red" }}>*</span>
    </Typography>
    <TextField
      required
      fullWidth
      select
      name="highestQualification"
      disabled={isFormAlreadySubmitted}
      value={formData?.highestQualification || ""}
      onChange={handleChange}
      InputProps={{
        ...inputPropsStyle,
        sx: {
          ...inputPropsStyle?.sx,
          fontFamily: "Lexend",
          pr: 2,
          color:
            !formData?.highestQualification ||
            formData?.highestQualification === ""
              ? "#9e9e9e"
              : "inherit",
          width: "100%",
        },
      }}
      SelectProps={{
        displayEmpty: true,
        MenuProps: {
          PaperProps: {
            sx: {
              backgroundColor: "white",
              pr: 2,
              borderRadius: "15px",
              "& .MuiMenuItem-root": {
                color: "#212121",
                "&.Mui-selected": {
                  backgroundColor: "#3DA3C4",
                },
              },
            },
          },
        },
      }}
      error={!!error?.highestQualification}
      helperText={error?.highestQualification}
    >
      <MenuItem value="" disabled sx={{ fontFamily: "Lexend", color: "#212121" }}>
        Select highest qualification
      </MenuItem>
      {qualificationOptions?.map((option) => (
        <MenuItem key={option} value={option} sx={{ fontFamily: "Lexend" }}>
          {option}
        </MenuItem>
      ))}
    </TextField>
    {formData?.highestQualification === "Other" && (
 <TextField
 required
 fullWidth
 name="otherQualification" // ✅ Use separate name for custom value
 placeholder="Please specify your qualification"
 value={formData?.otherQualification || ""} // ✅ Use a separate state variable
 onChange={handleChange}
 disabled={isFormAlreadySubmitted}
 sx={{ marginTop: 2 }}
 InputProps={{
   sx: {
     fontFamily: "Lexend",
     borderRadius: "15px",
   },
 }}
 error={!!error?.otherQualification} // ✅ Use separate error state
 helperText={error?.otherQualification}
/>
  )}
  </Grid>

  {[
    {
      label: "Latest Pay Slip",
      name: "latestPaySlip",
      required: false,
      helperText: "Only PDF or Word files are allowed",
      accept: ".pdf,.doc,.docx",
    },
    {
      label: "Last Appointment Letter",
      name: "lastAppointmentLetter",
      required: false,
      helperText: "Only PDF, PNG, JPG, or Word files are allowed",
      accept: ".pdf,.png,.jpg,.jpeg,.doc,.docx",
    },
    {
      label: "Degree Certificate *",
      name: "degreeCertificate",
      required: true,
      helperText: "Only PDF, PNG, JPG, or Word files are allowed",
      accept: ".pdf,.png,.jpg,.jpeg,.doc,.docx",
    },
    {
      label: "Identity Proof *",
      name: "identityProof",
      required: true,
      helperText: "Only PDF, PNG, JPG, or Word files are allowed",
      accept: ".pdf,.png,.jpg,.jpeg,.doc,.docx",
    },
  ].map((field) => (
    <Grid item xs={12} key={field.name}>
      <Typography sx={labelStyle}>
        {field.label.replace(" *", "")}
        {field.required && (
          <Box component="span" sx={{ color: "red", ml: 0.5 }}>
            *
          </Box>
        )}
      </Typography>
      <TextField
        fullWidth
        name={field.name}
        type="file"
        disabled={isFormAlreadySubmitted}
        onChange={handleChange}
        error={!!error?.[field.name]}
        inputProps={{ accept: field.accept }}
        helperText={
          error?.[field.name]
            ? typeof error?.[field.name] === "object"
              ? JSON.stringify(error?.[field.name])
              : error?.[field.name]
            : field.helperText
        }
        InputProps={{
          style: {
            width: "100%",
            borderRadius: "15px",
          },
          startAdornment: (
            <InputAdornment position="start">
              {/* Optional icon */}
            </InputAdornment>
          ),
          endAdornment: (filePreviews[field.name] || formData?.[field.name]) && (
            <InputAdornment position="end">
              <IconButton
                onClick={() =>
                  handleDownload(filePreviews[field.name] || formData?.[field.name])
                }
                aria-label={`Download ${field.label}`}
              >
                <VisibilityIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          style: {
            fontWeight: 500,
            fontSize: "14px",
          },
        }}
      />
      {formData[field.name] && formData[field.name].name && (
        <Typography variant="body2" sx={{ mt: 0.5, ml: 1 }}>
          Selected: {formData[field.name].name}
        </Typography>
      )}
    </Grid>
  ))}
</Grid>
              </>
            )}

            <Box
              sx={{
                mt: 4,
                pb: 4,
                display: "flex",
                justifyContent: "flex-end",
                gap: 3,
                borderRadius: "15px",
                flexWrap: "wrap",
              }}
            >
              {activeStep > 0 && (
                <Button
                  onClick={handleBack}
                  variant="outlined"
                  sx={commonButtonStyle}
                  startIcon={<ArrowBackIcon />}
                >
                  Back
                </Button>
              )}

              {activeStep === steps.length - 1 ? (
                !isFormAlreadySubmitted && (
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    disabled={isSubmitting}
                    sx={commonButtonStyle}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                )
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleNext}
                  sx={commonButtonStyle}
                  endIcon={<ArrowForwardIcon />}
                >
                  Continue
                </Button>
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Dialog
  open={dialogOpen}
  onClose={progressDialogStage !== "submitting" ? () => setDialogOpen(false) : undefined}
  disableEscapeKeyDown={progressDialogStage === "submitting"}
  PaperProps={{
    sx: {
      width: 450,
      maxWidth: "90vw",
      padding: 2,
      fontSize: "18px",
      fontFamily: "Lexend",
      color: "#000000DE",
      borderRadius: "19px",
    },
  }}
>
  <DialogContent>
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        mb: 3,
        mt: 2,
        position: "relative",
      }}
    >
      <CircularProgress
        variant="determinate"
        value={dialogProgress}
        size={80}
        thickness={2}
        sx={{
          color: progressDialogStage === "error" ? "#f44336" : "#0087B4",
          "& .MuiCircularProgress-circle": {
            strokeLinecap: "round",
          },
        }}
      />
      <Box
        sx={{
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 60,
          height: 80,
          opacity: showIcon ? 1 : 0,
          transform: showIcon ? "scale(1)" : "scale(0)",
          transition: "all 0.3s ease-in-out",
        }}
      >
        {progressDialogStage === "success" && (
          <CheckIcon
            sx={{
              height: 100,
              fontSize: 50,
              color: "#0087B4",
            }}
          />
        )}
        {progressDialogStage === "error" && (
          <PriorityHighIcon
            sx={{
              height: 100,
              fontSize: 50,
              color: "#f44336",
            }}
          />
        )}
      </Box>
    </Box>

    {progressDialogStage === "submitting" && (
      <Typography sx={{ textAlign: "center", fontFamily: "Lexend", fontSize: "18px", fontWeight: 400 }}>
        Submitting Application...
      </Typography>
    )}

    {(progressDialogStage === "success" || progressDialogStage === "error") && (
      <>
        <DialogTitle sx={{ textAlign: "center", fontSize: "20px", fontFamily: "Lexend", fontWeight: "bold", pb: 1 }}>
          {dialogTitle}
        </DialogTitle>
        <Typography sx={{ textAlign: "center", fontFamily: "Lexend", fontWeight:300, fontSize: "16px" }}>
          {dialogMessage}
        </Typography>
      </>
    )}
  </DialogContent>

  {progressDialogStage !== "submitting" && (
    <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
      <Button
        onClick={() => {
          setDialogOpen(false);
          if (progressDialogStage === "success" && website) {
            window.location.href = website;
          }
        }}
        variant="contained"
        sx={{
          backgroundColor: "#0087B4",
          "&:hover": {
            backgroundColor: "#006e96",
          },
          borderRadius: "8px",
          px: 4,
          py: 1,
          fontSize: "16px",
          fontFamily: "Lexend",
        }}
      >
        OK
      </Button>
    </DialogActions>
  )}
</Dialog>
    </Box>
  );
}
